(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-reviews-spotlight"] && !Shopify.designMode) return;
  try {
    
class PremiumVideoReviewsSpotlight {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.sliderViewport = this.section.querySelector('[data-vrs-slider]');
    this.cards = this.section.querySelectorAll('.vrs-card');
    this.sectionId = this.section.id.replace('shopify-section-', '');
    
    this.modal = document.getElementById(`vrsModal-${this.sectionId}`);
    this.modalVideo = document.getElementById(`vrsPortalVideo-${this.sectionId}`);
    this.sidebarContent = document.getElementById(`vrsPortalSidebarContent-${this.sectionId}`);
    
    this.activeCard = null;
    this.intersectionObserver = null;

    if(this.cards.length === 0) return;
    this.initSliderEngine();
    this.initPortalEvents();
  }

  initSliderEngine() {
    if ('IntersectionObserver' in window) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const card = entry.target;
          const video = card.querySelector('video');
          if (!video) return;

          if (entry.isIntersecting) {
            if (!video.src) {
              video.src = video.getAttribute('data-src');
              video.load();
            }
            video.play().then(() => {
              card.classList.add('is-playing');
              if (card.querySelector('[data-vrs-progress]')) {
                this.trackCardProgress(card, video);
              }
            }).catch(() => {});
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        });
      }, {
        root: this.sliderViewport,
        threshold: 0.6
      });

      this.cards.forEach(card => this.intersectionObserver.observe(card));
    }
  }

  trackCardProgress(card, video) {
    const progressBar = card.querySelector('[data-vrs-progress]');
    const updateLoop = () => {
      if (!video.paused && video.duration) {
        const percentage = (video.currentTime / video.duration) * 100;
        progressBar.style.width = `${percentage}%`;
      }
      if (card.classList.contains('is-playing')) {
        requestAnimationFrame(updateLoop);
      }
    };
    requestAnimationFrame(updateLoop);
  }

  initPortalEvents() {
    this.cards.forEach(card => {
      card.addEventListener('click', () => this.openPortal(card));
    });

    this.modal.querySelector('[data-vrs-close]').addEventListener('click', () => this.closePortal());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closePortal();
    });

    const playBtn = this.modal.querySelector('[data-vrs-ctrl-play]');
    playBtn.addEventListener('click', () => {
      if (this.modalVideo.paused) {
        this.modalVideo.play();
        playBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>';
      } else {
        this.modalVideo.pause();
        playBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
      }
    });

    const muteBtn = this.modal.querySelector('[data-vrs-ctrl-mute]');
    muteBtn.addEventListener('click', () => {
      this.modalVideo.muted = !this.modalVideo.muted;
      muteBtn.innerHTML = this.modalVideo.muted ? 
        '<svg viewBox="0 0 24 24"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77zM3 9v6h4l5 5V4L7 9H3z"/></svg>' :
        '<svg viewBox="0 0 24 24"><path d="M4.34 2.93L2.93 4.34 7.29 8.7H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06a8.94 8.94 0 003.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM10 15.17L7.83 13H5v-2h2.83l2.17-2.17v6.34zM12 4L9.91 6.09 12 8.18V4zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-5.02-4.15V5.79c1.48.73 2.5 2.25 2.5 4.02 0 .52-.1.1-.26.6l-1.49-1.49l-.75-.07z"/></svg>';
    });

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) this.closePortal();
    });
  }

  openPortal(card) {
    const rawPayload = card.querySelector('template[data-vrs-payload]').content.textContent;
    const payload = JSON.parse(rawPayload);

    this.modalVideo.src = payload.videoUrl;
    this.modalVideo.muted = false; 
    this.modalVideo.play().catch(() => {});

    let sidebarHtml = `
      <div class="vrs-meta-row">
        <div class="vrs-reviewer-group" style="font-size: 18px;">
          <span>${payload.name}</span>
          ${payload.verified ? `<svg class="vrs-verified-icon" style="width:18px;height:18px;" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>` : ''}
        </div>
        ${payload.designation ? `<span class="vrs-designation" style="font-size:13px;">${payload.designation}</span>` : ''}
      </div>
      <div class="vrs-stars" style="margin: 12px 0;">
    `;

    for (let i = 0; i < payload.rating; i++) {
      sidebarHtml += `<svg viewBox="0 0 24 24" style="width:16px;height:16px;"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
    }

    sidebarHtml += `</div>`;

    if (payload.productConfigured) {
      const prod = payload.product;
      sidebarHtml += `
        <div class="vrs-product-pane">
          <span class="vrs-pane-vendor">${prod.vendor}</span>
          <h3 class="vrs-pane-title">${prod.title}</h3>
          <div class="vrs-pane-pricing">
            <span>${prod.price}</span>
            ${prod.comparePrice ? `<span class="vrs-pane-compare">${prod.comparePrice}</span>` : ''}
            ${prod.discount ? `<span class="vrs-pane-discount">SAVE ${prod.discount}%</span>` : ''}
          </div>
          
          <form data-vrs-atc-form>
            <select name="id" class="vrs-selector-element" ${prod.variants.length === 1 ? 'style="display:none;"' : ''}>
              ${prod.variants.map(v => `<option value="${v.id}" ${!v.available ? 'disabled' : ''}>${v.title} ${!v.available ? '- Sold Out' : ''}</option>`).join('')}
            </select>
            <button type="submit" class="vrs-atc-submit" ${!prod.available ? 'disabled' : ''}>
              ${prod.available ? 'ADD TO CART' : 'SOLD OUT'}
            </button>
          </form>
        </div>
      `;
    }

    this.sidebarContent.innerHTML = sidebarHtml;

    const form = this.sidebarContent.querySelector('[data-vrs-atc-form]');
    if (form) {
      form.addEventListener('submit', (e) => this.handleCartSubmit(e, form));
    }

    this.modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  handleCartSubmit(e, form) {
    e.preventDefault();
    const submitBtn = form.querySelector('.vrs-atc-submit');
    const variantId = form.querySelector('[name="id"]').value;

    submitBtn.disabled = true;
    submitBtn.textContent = 'ADDING TO CART...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(res => res.json())
    .then(() => {
      submitBtn.textContent = 'ADDED SUCCESSFULLY!';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxCart:update', { bubbles: true })); 
      setTimeout(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = 'ADD TO CART';
      }, 2000);
    })
    .catch(() => {
      submitBtn.textContent = 'ERROR ADDING ITEM';
      submitBtn.disabled = false;
    });
  }

  closePortal() {
    this.modal.classList.remove('is-active');
    this.modalVideo.pause();
    this.modalVideo.src = '';
    document.body.style.overflow = '';
  }

  destroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
}

document.addEventListener('shopify:section:load', (e) => {
  const vrsTarget = e.target.querySelector('.vrs-section');
  if (vrsTarget || e.target.classList.contains('vrs-section')) {
    new PremiumVideoReviewsSpotlight(e.target.closest('.shopify-section'));
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.vrs-section').forEach(el => {
    new PremiumVideoReviewsSpotlight(el.closest('.shopify-section'));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories"] && !Shopify.designMode) return;
  try {
    
class VideoStories {
  constructor(sectionId) {
    this.section = document.getElementById(`shopify-section-${sectionId}`);
    if (!this.section) return;
    
    this.modal = document.getElementById(`vsModal-${sectionId}`);
    this.modalVideo = document.getElementById(`vsModalVideo-${sectionId}`);
    this.closeBtn = this.modal.querySelector('.vs-modal-close');
    this.productTarget = this.modal.querySelector('.vs-dynamic-product-target');
    this.storyItems = this.section.querySelectorAll('.vs-item');
    this.previewVideos = this.section.querySelectorAll('.vs-preview-video');
    
    this.init();
  }

  init() {
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.25 });

      this.previewVideos.forEach(video => videoObserver.observe(video));
    }

    this.storyItems.forEach(item => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.vs-badge')) return;
        
        const redirectLink = item.getAttribute('data-link');
        const target = item.getAttribute('data-target');
        const videoUrl = item.getAttribute('data-video-url');
        
        if (redirectLink && !videoUrl) {
          window.open(redirectLink, target);
          return;
        }
        
        this.openStory(item);
      });
    });

    this.closeBtn.addEventListener('click', () => this.closeStory());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeStory();
    });
    
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.closeStory();
      }
    });

    this.productTarget.addEventListener('click', (e) => {
      const atcBtn = e.target.closest('.vs-prod-atc[data-variant-id]');
      if (atcBtn) {
        e.preventDefault();
        this.handleAddToCart(atcBtn.getAttribute('data-variant-id'), atcBtn);
      }
    });
  }

  openStory(item) {
    const videoUrl = item.getAttribute('data-video-url');
    const blockId = item.getAttribute('data-block-id');
    
    if (!videoUrl) return;

    this.modalVideo.src = videoUrl;
    this.modalVideo.load();
    this.modalVideo.play().catch(() => {});

    this.productTarget.innerHTML = '';
    const template = item.querySelector(`template[data-product-json-${blockId}]`);
    if (template) {
      const content = template.content.cloneNode(true);
      this.productTarget.appendChild(content);
    }

    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeStory() {
    this.modal.classList.remove('is-open');
    this.modalVideo.pause();
    this.modalVideo.src = '';
    document.body.style.overflow = '';
  }

  handleAddToCart(variantId, button) {
    button.textContent = 'Adding...';
    button.disabled = true;

    const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }]
      })
    })
    .then(response => response.json())
    .then(() => {
      button.textContent = 'Added!';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(() => { button.textContent = 'Add'; button.disabled = false; }, 2000);
    })
    .catch((error) => {
      console.error('Error:', error);
      button.textContent = 'Error';
      setTimeout(() => { button.textContent = 'Add'; button.disabled = false; }, 2000);
    });
  }
}

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.classList.contains('vs-section') || e.target.querySelector('.vs-section')) {
    new VideoStories(e.detail.sectionId);
  }
});

const vsInstances = document.querySelectorAll('.vs-section');
vsInstances.forEach(el => {
  const sectionContainer = el.closest('.shopify-section');
  if (sectionContainer) {
    const sectionId = sectionContainer.id.replace('shopify-section-', '');
    new VideoStories(sectionId);
  }
});

  } catch(e) { console.error(e); }
})();
})();
